import * as React from 'react'
import './input-select.scss'

export const InputSelect = ({
  label,
  placeholder = '',
  name = '',
  className = '',
  register,
  validations = {},
  errors = {},
  messageError,
  options = [],
  color = '',
  hidden = false,
  isSearcher = true,
  setValue,
  onChange,
}) => {
  const [isOpenOptions, setIsOpenOptions] = React.useState(false)
  const [filteredOptions, setFilteredOptions] = React.useState(options)
  const inputRef = React.useRef(null)
  const wrapperRef = React.useRef(null)
  const { ref, restRegister } = register(name, validations)

  const handleButtonOptions = e => {
    e?.preventDefault()
    setIsOpenOptions(v => !v)
  }

  const filterOptions = optionToFilter => {
    if (optionToFilter !== '' && optionToFilter !== ' ') {
      let optionsFiltered = options.filter(option => {
        return option.name?.toLowerCase().includes(optionToFilter.toLowerCase())
      })

      setFilteredOptions(optionsFiltered)
    }
  }

  const handleInputClick = e => {
    if (errors[name] || messageError) return

    if (isSearcher) {
      setIsOpenOptions(true)
    } else {
      handleButtonOptions(e)
    }
  }

  const handleInputKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault()

      let inputOption = e.target.value.toLowerCase()
      let findedOption = filteredOptions.find(
        option => option.name.toLowerCase() === inputOption
      )

      if (findedOption?.name) {
        setValue(findedOption?.name || '')
        onChange && onChange(findedOption)
        handleButtonOptions()
      }
    }
  }

  const handleOption = option => {
    setValue && setValue(name, option.name)
    setIsOpenOptions(false)
  }

  React.useEffect(() => {
    options && options.length > 0 && setFilteredOptions(options)
  }, [options])

  React.useEffect(() => {
    const handleClickOutside = event => {
      if (!wrapperRef?.current?.contains(event.target)) {
        setIsOpenOptions(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={`f-college__select ${color} ${className} `}
      hidden={hidden}
      ref={wrapperRef}
    >
      {label && (
        <span id="select-label" className="f-college__select__label">
          {label}
        </span>
      )}

      <div className="f-college__select__field">
        <div className="f-college__select__field__selected-option">
          <input
            id={name}
            aria-labelledby={`select-label ${name}`}
            readOnly={!isSearcher}
            placeholder={placeholder}
            onChange={e => filterOptions(e.target.value)}
            onClick={handleInputClick}
            onKeyDown={handleInputKeyDown}
            autoComplete="off"
            {...restRegister}
            ref={e => {
              ref(e)
              inputRef.current = e
            }}
          />
          <i
            role="button"
            aria-hidden="true"
            aria-label="desplegar"
            className="fas fa-sort-down"
            onClick={handleButtonOptions}
          />
        </div>

        <div
          className={`f-college__select__field__options-wrapper ${
            isOpenOptions
              ? 'f-college__select__field__options-wrapper--active'
              : ''
          }`}
        >
          <ul className={`f-college__select__field__options`}>
            {filteredOptions?.map(option => {
              const activeOption = inputRef?.current?.value
              let isActive = activeOption === option.name

              return (
                <li
                  key={option.value}
                  rol="button"
                  aria-hidden="true"
                  aria-label="opcion"
                  className={`f-college__select__field__options__option ${
                    isActive
                      ? 'f-college__select__field__options__option--active'
                      : ''
                  }`}
                  onClick={() => {
                    handleOption(option)
                    onChange && onChange(option)
                  }}
                >
                  {option.name}
                </li>
              )
            })}
          </ul>
        </div>
      </div>

      {((errors && errors[name]) || messageError) && (
        <span className="f-college__select__field__error">
          {errors[name].message || messageError}
        </span>
      )}
    </div>
  )
}
